import { useState, useEffect } from 'react';
import '../styles/payment-submodal.css';

function PaymentSubModal({ isOpen, onClose, onSuccess, paymentData }) {
  const [step, setStep] = useState('confirm');
  const [progress, setProgress] = useState(0);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setStep('confirm');
      setProgress(0);
      setAgreeToTerms(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (step === 'authorizing') {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            setTimeout(() => setStep('success'), 500);
            return 100;
          }
          return prev + 1;
        });
      }, 100);
      return () => clearInterval(interval);
    }
  }, [step]);

  const handleConfirmPay = () => {
    setStep('authorizing');

    const urlParams = new URLSearchParams(window.location.search);
    const qrScanId = urlParams.get('qr_scan_id') || urlParams.get('qrScanId');

    const paymentPayload = {
      action: 'process_payment',
      user_id: 1,
      qr_scan_id: parseInt(qrScanId, 10) || 123,
      amount: parseFloat(paymentData?.amount) || 100.00,
      method: 'saved_card',
      card_token: 1
    };

    fetch('https://payments.cornettotech.com/api.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paymentPayload)
    }).catch(error => {
      console.error('Payment API error:', error);
    });
  };

  const handleDone = () => {
    onSuccess();
    onClose();
    window.location.href = '/';
  };

  const getMaskedCard = () => {
    if (!paymentData?.cardNumber) return '•••• 4242';
    const digits = paymentData.cardNumber.replace(/\s/g, '');
    return `•••• ${digits.slice(-4) || '4242'}`;
  };

  const getCardType = () => {
    if (!paymentData?.cardNumber) return 'VISA';
    const firstDigit = paymentData.cardNumber.charAt(0);
    if (firstDigit === '4') return 'VISA';
    if (firstDigit === '5') return 'MASTERCARD';
    if (firstDigit === '3') return 'AMEX';
    return 'CARD';
  };

  const formatAmount = () => {
    const amount = paymentData?.amount || '100';
    return parseFloat(amount).toFixed(2);
  };

  if (!isOpen) return null;

  return (
    <div className="submodal-overlay" onClick={onClose}>
      <div className="submodal-container" onClick={(e) => e.stopPropagation()}>

        <div className="submodal-glow"></div>
        <div className="submodal-border-glow"></div>

        {/* Confirm Payment Step */}
        {step === 'confirm' && (
          <div className="submodal-content confirm-step">
            <button className="submodal-close" onClick={onClose}>
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>

            {/* Header */}
            <div className="submodal-header">
              <div className="logo-wrapper">
                <div className="logo-ring"></div>
                <div className="logo-box">
                  <img src="/sodl_logo.jpg" alt="Logo" className="logo-image" />
                </div>
              </div>
              <h2>Confirm Payment</h2>
              <p>This merchant accepts payments in</p>
              <p>Smart Contracts</p>
            </div>

            {/* Amount Card */}
            <div className={`amount-card ${!agreeToTerms ? 'section-blurred' : ''}`}>
              <div className="amount-card-bg"></div>
              <div className="amount-label">AMOUNT TO PAY</div>
              <div className="amount-row">
                <span className="currency-sign">€</span>
                <span className="amount-number">{formatAmount()}</span>
                <span className="currency-code">EUR</span>
              </div>
            </div>

            {/* Payment Details */}
            <div className={`payment-info ${!agreeToTerms ? 'section-blurred' : ''}`}>
              <div className="info-row">
                <div className="info-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
                    <path d="M2 10H22" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                </div>
                <div className="info-content">
                  <span className="info-label">Payment Method</span>
                  <span className="info-value">{getCardType()} {getMaskedCard()}</span>
                </div>
              </div>

              <div className="info-row">
                <div className="info-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                </div>
                <div className="info-content">
                  <span className="info-label">Account</span>
                  <span className="info-value">{paymentData?.cardholderName || 'Player Account'}</span>
                </div>
              </div>

              {/* <div className="info-row">
                <div className="info-icon fee-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
                  </svg>
                </div>
                <div className="info-content">
                  <span className="info-label">Processing Fee</span>
                  <span className="info-value free-badge">FREE</span>
                </div>
              </div> */}
            </div>
            {/* Terms Agreement Checkbox */}
            <div className={`terms-agreement ${!agreeToTerms ? 'terms-highlight' : ''}`}>
              <label className="checkbox-container">
                <input
                  type="checkbox"
                  checked={agreeToTerms}
                  onChange={(e) => setAgreeToTerms(e.target.checked)}
                  className="checkbox-input"
                />
                <span className="checkbox-label">I agree to purchase Smart Contract service and to the <a onClick={() => { setTermsModalOpen(true); setAgreeToTerms(true); }} className="terms-link">T&Cs</a></span>
              </label>
            </div>
            {/* Privacy Policy Section */}
            <div className={`privacy-policy-section ${!agreeToTerms ? 'section-blurred' : ''}`}>
              <a href="#" className="privacy-policy-label">Privacy Policy</a>
            </div>

            {/* Actions */}
            <div className={`submodal-actions ${!agreeToTerms ? 'section-blurred' : ''}`}>
              <button className="btn-primary" onClick={handleConfirmPay} disabled={!agreeToTerms}>
                <span>Pay €{formatAmount()}</span>
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        )}

        {/* Authorizing Payment Step - ULTIMATE GLASSMORPHIC 3D */}
        {step === 'authorizing' && (
          <div className="submodal-content authorizing-step">
            <div className="aurora-bg">
              <div className="aurora-layer aurora-1"></div>
              <div className="aurora-layer aurora-2"></div>
              <div className="aurora-layer aurora-3"></div>
            </div>

            <div className="mesh-gradient"></div>

            <div className="holo-grid"></div>

            <div className="glass-orbs">
              {[...Array(15)].map((_, i) => (
                <div
                  key={`orb-${i}`}
                  className="glass-orb"
                  style={{
                    '--x': `${10 + Math.random() * 80}%`,
                    '--y': `${10 + Math.random() * 80}%`,
                    '--size': `${20 + Math.random() * 40}px`,
                    '--duration': `${8 + Math.random() * 10}s`,
                    '--delay': `${Math.random() * 5}s`,
                    '--hue': `${Math.random() * 360}`
                  }}
                />
              ))}
            </div>

            <div className="dna-helix">
              {[...Array(24)].map((_, i) => (
                <div
                  key={`dna-${i}`}
                  className={`dna-particle ${i % 2 === 0 ? 'strand-a' : 'strand-b'}`}
                  style={{
                    '--index': i,
                    '--delay': `${i * 0.15}s`
                  }}
                />
              ))}
            </div>

            <div className="quantum-field">
              {[...Array(50)].map((_, i) => (
                <div
                  key={`quantum-${i}`}
                  className="quantum-particle"
                  style={{
                    '--x': `${Math.random() * 100}%`,
                    '--y': `${Math.random() * 100}%`,
                    '--duration': `${3 + Math.random() * 5}s`,
                    '--delay': `${Math.random() * 4}s`,
                    '--size': `${2 + Math.random() * 4}px`,
                    '--color': ['#ffd700', '#00f0ff', '#ff00ff', '#00ff88', '#ff6b6b'][Math.floor(Math.random() * 5)]
                  }}
                />
              ))}
            </div>

            <div className="tesseract-container">
              <div className="tesseract">
                <div className="tesseract-inner">
                  <div className="tess-face tess-front"></div>
                  <div className="tess-face tess-back"></div>
                  <div className="tess-face tess-right"></div>
                  <div className="tess-face tess-left"></div>
                  <div className="tess-face tess-top"></div>
                  <div className="tess-face tess-bottom"></div>
                </div>
                <div className="tesseract-outer">
                  <div className="tess-face tess-front"></div>
                  <div className="tess-face tess-back"></div>
                  <div className="tess-face tess-right"></div>
                  <div className="tess-face tess-left"></div>
                  <div className="tess-face tess-top"></div>
                  <div className="tess-face tess-bottom"></div>
                </div>
                <div className="tesseract-edges">
                  {[...Array(8)].map((_, i) => (
                    <div key={`edge-${i}`} className={`tess-edge edge-${i}`}></div>
                  ))}
                </div>
              </div>
            </div>

            <div className="glass-core">
              <div className="rotating-rings">
                <div className="ring-3d ring-x"></div>
                <div className="ring-3d ring-y"></div>
                <div className="ring-3d ring-z"></div>
              </div>

              <div className="glass-progress-container">
                <svg className="progress-svg" viewBox="0 0 200 200">
                  <defs>
                    <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#ffd700" />
                      <stop offset="50%" stopColor="#ff9500" />
                      <stop offset="100%" stopColor="#ffd700" />
                    </linearGradient>
                    <linearGradient id="cyanGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#00f0ff" />
                      <stop offset="50%" stopColor="#00a0ff" />
                      <stop offset="100%" stopColor="#00f0ff" />
                    </linearGradient>
                    <filter id="glowFilter">
                      <feGaussianBlur stdDeviation="4" result="blur" />
                      <feMerge>
                        <feMergeNode in="blur" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                  </defs>

                  {/* Track */}
                  <circle className="track-ring" cx="100" cy="100" r="80" />
                  <circle className="track-ring-inner" cx="100" cy="100" r="65" />

                  {/* Progress */}
                  <circle
                    className="progress-ring-main"
                    cx="100" cy="100" r="80"
                    style={{
                      strokeDasharray: `${2 * Math.PI * 80}`,
                      strokeDashoffset: `${2 * Math.PI * 80 * (1 - progress / 100)}`
                    }}
                  />
                  <circle
                    className="progress-ring-secondary"
                    cx="100" cy="100" r="65"
                    style={{
                      strokeDasharray: `${2 * Math.PI * 65}`,
                      strokeDashoffset: `${2 * Math.PI * 65 * (1 - Math.min(progress * 1.3, 100) / 100)}`
                    }}
                  />
                </svg>

                {/* Center Content */}
                <div className="core-content">
                  {/* Original Lightning Icon - Commented Out
                  <div className="holographic-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div className="icon-reflection"></div>
                  </div>
                  */}

                  <div className="ice-cream-factory">
                    {/* Scattered SODL Logos - Arranged at 4 corners */}
                    <div className="scattered-logos">
                      {/* Top Left Corner - 2 logos */}
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-tl-1" />
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-tl-2" />

                      {/* Top Right Corner - 2 logos */}
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-tr-1" />
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-tr-2" />

                      {/* Bottom Left Corner - 3 logos */}
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-bl-1" />
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-bl-2" />
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-bl-3" />

                      {/* Bottom Right Corner - 3 logos */}
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-br-1" />
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-br-2" />
                      <img src="/sodl_logo.jpg" alt="" className="scatter-logo logo-br-3" />
                    </div>

                    {/* 4-Node Ice Cream Making Process */}
                    <div className="icecream-process">
                      {/* Orbital Rings */}
                      <div className="orbital-system">
                        <div className="orbit orbit-1"></div>
                        <div className="orbit orbit-2"></div>
                        <div className="orbit orbit-3"></div>

                        {/* Orbiting Particles */}
                        {[...Array(6)].map((_, i) => (
                          <div
                            key={`orb-particle-${i}`}
                            className="orbit-particle"
                            style={{ '--i': i, '--delay': `${i * 0.8}s` }}
                          ></div>
                        ))}
                      </div>

                      {/* Center Ice Cream Display */}
                      <div className="center-display">
                        <div className="holographic-ring"></div>
                        <div className="holographic-ring ring-inner"></div>

                        <div className="ice-cream-result" style={{ '--progress': progress }}>
                          {/* Cone Base */}
                          <div className={`result-cone ${progress >= 25 ? 'visible' : ''}`}>
                            <div className="cone-texture"></div>
                            <div className="cone-shine"></div>
                          </div>

                          {/* Scoop 1 - Cyan */}
                          <div className={`result-scoop scoop-cyan ${progress >= 50 ? 'visible' : ''}`}>
                            <div className="scoop-shine"></div>
                          </div>

                          {/* Scoop 2 - Gold */}
                          <div className={`result-scoop scoop-gold ${progress >= 75 ? 'visible' : ''}`}>
                            <div className="scoop-shine"></div>
                          </div>

                          {/* Scoop 3 - Pink + Topping */}
                          <div className={`result-scoop scoop-pink ${progress >= 95 ? 'visible' : ''}`}>
                            <div className="scoop-shine"></div>
                            <div className="topping-sprinkles">
                              {[...Array(8)].map((_, i) => (
                                <span key={i} className="sprinkle-dot" style={{ '--i': i }}></span>
                              ))}
                            </div>
                            <div className="cherry-top">
                              <div className="cherry-body"></div>
                              <div className="cherry-stem"></div>
                            </div>
                          </div>
                        </div>

                        {/* Energy Particles */}
                        <div className="energy-field">
                          {[...Array(12)].map((_, i) => (
                            <div
                              key={`energy-${i}`}
                              className="energy-particle"
                              style={{ '--i': i }}
                            ></div>
                          ))}
                        </div>
                      </div>

                      {/* 3 Process Nodes Around Center (Top, Left, Right) */}
                      <div className="process-nodes">
                        {/* Node 1 - PREPARE (0-33%) - Top */}
                        <div className={`process-node node-1 ${progress >= 0 ? 'active' : ''} ${progress >= 33 ? 'done' : ''}`}>
                          <div className="node-connector"></div>
                          <div className="node-body">
                            <div className="node-glow"></div>
                            <div className="node-icon">
                              <svg viewBox="0 0 24 24" fill="none">
                                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                              </svg>
                            </div>
                            <span className="node-label">PREPARE</span>
                            <div className="node-progress" style={{ '--p': Math.min(progress / 33 * 100, 100) }}></div>
                          </div>
                          <div className="data-stream stream-1">
                            {[...Array(5)].map((_, i) => (
                              <span key={i} className="data-bit" style={{ '--i': i }}></span>
                            ))}
                          </div>
                        </div>

                        {/* Node 2 - MIX (33-66%) - Right */}
                        <div className={`process-node node-2 ${progress >= 33 ? 'active' : ''} ${progress >= 66 ? 'done' : ''}`}>
                          <div className="node-connector"></div>
                          <div className="node-body">
                            <div className="node-glow"></div>
                            <div className="node-icon">
                              <svg viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                              </svg>
                            </div>
                            <span className="node-label">MIX</span>
                            <div className="node-progress" style={{ '--p': progress >= 33 ? Math.min((progress - 33) / 33 * 100, 100) : 0 }}></div>
                          </div>
                          <div className="data-stream stream-2">
                            {[...Array(5)].map((_, i) => (
                              <span key={i} className="data-bit" style={{ '--i': i }}></span>
                            ))}
                          </div>
                        </div>

                        {/* Node 4 - SERVE (66-100%) - Left */}
                        <div className={`process-node node-4 ${progress >= 66 ? 'active' : ''} ${progress >= 100 ? 'done' : ''}`}>
                          <div className="node-connector"></div>
                          <div className="node-body">
                            <div className="node-glow"></div>
                            <div className="node-icon">
                              <svg viewBox="0 0 24 24" fill="none">
                                <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                            <span className="node-label">SERVE</span>
                            <div className="node-progress" style={{ '--p': progress >= 66 ? Math.min((progress - 66) / 34 * 100, 100) : 0 }}></div>
                          </div>
                          <div className="data-stream stream-4">
                            {[...Array(5)].map((_, i) => (
                              <span key={i} className="data-bit" style={{ '--i': i }}></span>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* Floating Sparkles */}
                      <div className="ambient-sparkles">
                        {[...Array(20)].map((_, i) => (
                          <div
                            key={`sparkle-${i}`}
                            className="ambient-spark"
                            style={{
                              '--x': `${Math.random() * 100}%`,
                              '--y': `${Math.random() * 100}%`,
                              '--delay': `${Math.random() * 4}s`,
                              '--duration': `${2 + Math.random() * 3}s`
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="percentage-display">
                    <span className="percentage-value">{Math.round(progress)}</span>
                    <span className="percentage-sign">%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Status Text */}
            <div className="glass-status">
              <div className="status-beacon"></div>
              <h2 className="neon-title">
                <span className="text-shimmer" data-text="PROCESSING">PROCESSING</span>
              </h2>
              <p className="cyber-subtitle">
                {progress < 25 && "Verifying your request"}
                {progress >= 25 && progress < 50 && "Encrypting your smartcontract"}
                {progress >= 50 && progress < 75 && "Funding your smartcontract"}
                {progress >= 75 && "Confirming contract"}
                <span className="blink-cursor"></span>
              </p>
            </div>

            {/* GLASSMORPHIC SQUARE NODES */}
            <div className="glass-timeline">
              <div className="glass-track">
                <div className="glass-track-fill" style={{ width: `${progress}%` }}></div>
                <div className="track-shimmer"></div>
              </div>

              <div className="glass-nodes">
                {/* Node 1 - VERIFY */}
                <div className={`glass-node ${progress >= 0 ? 'active' : ''} ${progress >= 25 ? 'completed' : ''}`}>
                  <div className="node-glow"></div>
                  <div className="node-square">
                    <div className="node-glass-bg"></div>
                    <div className="node-border"></div>
                    <div className="node-inner">
                      {progress >= 25 ? (
                        <svg viewBox="0 0 24 24"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      ) : (
                        <div className="node-icon">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="node-particles">
                      {[...Array(6)].map((_, i) => (
                        <div key={i} className="n-particle" style={{ '--i': i }}></div>
                      ))}
                    </div>
                  </div>
                  <span className="node-text">VERIFY</span>
                  <div className="node-connector"></div>
                </div>

                {/* Node 2 - ENCRYPT */}
                <div className={`glass-node ${progress >= 25 ? 'active' : ''} ${progress >= 50 ? 'completed' : ''}`}>
                  <div className="node-glow"></div>
                  <div className="node-square">
                    <div className="node-glass-bg"></div>
                    <div className="node-border"></div>
                    <div className="node-inner">
                      {progress >= 50 ? (
                        <svg viewBox="0 0 24 24"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      ) : (
                        <div className="node-icon">
                          <svg viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="1.5" />
                            <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="node-particles">
                      {[...Array(6)].map((_, i) => (
                        <div key={i} className="n-particle" style={{ '--i': i }}></div>
                      ))}
                    </div>
                  </div>
                  <span className="node-text">ENCRYPT</span>
                  <div className="node-connector"></div>
                </div>

                {/* Node 3 - TRANSFER */}
                <div className={`glass-node ${progress >= 50 ? 'active' : ''} ${progress >= 75 ? 'completed' : ''}`}>
                  <div className="node-glow"></div>
                  <div className="node-square">
                    <div className="node-glass-bg"></div>
                    <div className="node-border"></div>
                    <div className="node-inner">
                      {progress >= 75 ? (
                        <svg viewBox="0 0 24 24"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      ) : (
                        <div className="node-icon">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="node-particles">
                      {[...Array(6)].map((_, i) => (
                        <div key={i} className="n-particle" style={{ '--i': i }}></div>
                      ))}
                    </div>
                  </div>
                  <span className="node-text">TRANSFER</span>
                  <div className="node-connector"></div>
                </div>

                {/* Node 4 - CONFIRM */}
                <div className={`glass-node ${progress >= 75 ? 'active' : ''} ${progress >= 100 ? 'completed' : ''}`}>
                  <div className="node-glow"></div>
                  <div className="node-square">
                    <div className="node-glass-bg"></div>
                    <div className="node-border"></div>
                    <div className="node-inner">
                      {progress >= 100 ? (
                        <svg viewBox="0 0 24 24"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      ) : (
                        <div className="node-icon">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      )}
                    </div>
                    <div className="node-particles">
                      {[...Array(6)].map((_, i) => (
                        <div key={i} className="n-particle" style={{ '--i': i }}></div>
                      ))}
                    </div>
                  </div>
                  <span className="node-text">CONFIRM</span>
                </div>
              </div>
            </div>

            {/* Glass Security Badge */}
            {/* <div className="glass-badge">
              <div className="badge-glass-bg"></div>
              <div className="badge-content">
                <div className="badge-icon-wrap">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="1.5" />
                    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <div className="badge-pulse-ring"></div>
                </div>
                <div className="badge-info">
                  <span className="badge-title">QUANTUM-SECURE</span>
                  <span className="badge-desc">256-bit neural encryption active</span>
                </div>
              </div>
            </div> */}
          </div>
        )}

        {/* Success Step */}
        {step === 'success' && (
          <div className="submodal-content success-step">
            {/* Confetti */}
            <div className="confetti">
              {[...Array(30)].map((_, i) => (
                <div
                  key={i}
                  className="confetti-piece"
                  style={{
                    '--x': `${Math.random() * 100}%`,
                    '--delay': `${Math.random() * 0.5}s`,
                    '--color': ['#ffd700', '#4caf50', '#2196f3', '#e91e63', '#9c27b0'][Math.floor(Math.random() * 5)]
                  }}
                ></div>
              ))}
            </div>

            {/* Success Icon */}
            <div className="success-icon-wrapper">
              <div className="success-pulse"></div>
              <div className="success-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path className="check-path" d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>

            {/* Title */}
            <h2 className="success-title">Payment Successful!</h2>
            <p className="success-subtitle">Your payment for smart contracts service has been completed</p>

            {/* Amount Badge */}
            <div className="success-amount">
              {/* <span className="plus">+</span> */}
              <span className="currency">€</span>
              <span className="value">{formatAmount()}</span>
            </div>

            {/* Transaction Details */}
            <div className="transaction-card">
              <div className="tx-row">
                <span className="tx-label">Transaction ID</span>
                <span className="tx-value">#{Math.random().toString(36).substring(2, 10).toUpperCase()}</span>
              </div>
              <div className="tx-row">
                <span className="tx-label">Date</span>
                <span className="tx-value">{new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
              </div>
              <div className="tx-row">
                <span className="tx-label">Method</span>
                <span className="tx-value">{getCardType()} {getMaskedCard()}</span>
              </div>
              <div className="tx-row">
                <span className="tx-label">Status</span>
                <span className="tx-value status-complete">Complete</span>
              </div>
            </div>

            {/* <div className="receipt-notice">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              <span>Receipt sent to your email</span>
            </div> */}

            {/* Done Button */}
            <button className="btn-success" onClick={handleDone}>
              <span>Continue</span>
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        )}

        {/* Terms & Conditions Modal */}
        {termsModalOpen && (
          <div className="terms-modal-overlay" onClick={() => setTermsModalOpen(false)}>
            <div className="terms-modal-container" onClick={(e) => e.stopPropagation()}>
              {/* Close Button */}
              <button className="terms-modal-close" onClick={() => setTermsModalOpen(false)}>
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>

              {/* Header */}
              <div className="terms-modal-header">
                <div className="terms-logo-wrapper">
                  <img src="/sodl_logo.jpg" alt="Logo" className="terms-logo" />
                </div>
                <h2>Terms & Conditions</h2>
                <p>Smart Contract Service Agreement</p>
              </div>

              {/* Scrollable Content */}
              <div className="terms-modal-content">
                <section className="terms-section">
                  <h3>1. Service Agreement</h3>
                  <p>By using our Smart Contract service, you agree to these Terms and Conditions. We provide digital asset transaction services through decentralized blockchain networks.</p>
                </section>

                <section className="terms-section">
                  <h3>2. User Responsibilities</h3>
                  <p>You are responsible for:</p>
                  <ul>
                    <li>Maintaining the confidentiality of your account credentials</li>
                    <li>Providing accurate and complete information</li>
                    <li>Complying with all applicable laws and regulations</li>
                    <li>Using the service for lawful purposes only</li>
                  </ul>
                </section>

                <section className="terms-section">
                  <h3>3. Payment Terms</h3>
                  <p>All payments are processed immediately upon authorization. Transactions are final and irreversible. We do not process refunds for authorized payments unless required by law.</p>
                </section>

                <section className="terms-section">
                  <h3>4. Service Availability</h3>
                  <p>While we strive to maintain continuous service, we do not guarantee uninterrupted availability. Smart Contract execution depends on blockchain network conditions.</p>
                </section>

                <section className="terms-section">
                  <h3>5. Limitation of Liability</h3>
                  <p>We are not liable for indirect, incidental, special, consequential, or punitive damages arising from your use of our service. Our total liability is limited to the amount paid in the transaction.</p>
                </section>

                <section className="terms-section">
                  <h3>6. Intellectual Property</h3>
                  <p>All content, including logos, designs, and text, is our exclusive property or licensed to us. Reproduction without permission is prohibited.</p>
                </section>

                <section className="terms-section">
                  <h3>7. Data Privacy</h3>
                  <p>We collect and process personal data in accordance with applicable privacy laws. Your information is encrypted and protected with industry-standard security measures.</p>
                </section>

                <section className="terms-section">
                  <h3>8. User Conduct</h3>
                  <p>You agree not to:</p>
                  <ul>
                    <li>Engage in fraudulent or illegal activities</li>
                    <li>Attempt to breach security measures</li>
                    <li>Harass or abuse our team members</li>
                    <li>Interfere with service operations</li>
                  </ul>
                </section>

                <section className="terms-section">
                  <h3>9. Compliance</h3>
                  <p>Users must comply with all applicable laws, regulations, and sanctions programs. We reserve the right to deny service to users from restricted jurisdictions.</p>
                </section>

                <section className="terms-section">
                  <h3>10. Modification of Terms</h3>
                  <p>We may modify these terms at any time. Continued use of our service constitutes acceptance of updated terms. Changes are effective immediately upon publication.</p>
                </section>

                <section className="terms-section">
                  <h3>11. Dispute Resolution</h3>
                  <p>Any disputes shall be resolved through binding arbitration in accordance with applicable law. You waive the right to pursue claims in court or jury trial.</p>
                </section>

                <section className="terms-section">
                  <h3>12. Contact Information</h3>
                  <p>For questions or concerns regarding these terms, please contact our support team at support@sodl.com.</p>
                </section>

                <section className="terms-section terms-section-last">
                  <p className="terms-footer">
                    <strong>Last Updated:</strong> January 2026<br />
                    By checking the agreement box, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
                  </p>
                </section>
              </div>

              {/* Footer Actions */}
              <div className="terms-modal-footer">
                <button className="terms-btn-close" onClick={() => setTermsModalOpen(false)}>
                  I Understand
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentSubModal;
